import { flightsLocalStore } from "@flights/web-api-utils-universal";
const STORAGE_KEY = "flights-dev-overrides";
const storage = flightsLocalStore || undefined;
export const getAll = () => {
    return storage?.get(STORAGE_KEY) || {};
};
export const setAll = (data) => {
    return storage?.set(STORAGE_KEY, data);
};
